import React, { useState } from 'react';
import './Groups.css';
import Header from './Header';

const peopleData = [
  {
    id: 1,
    name: 'Jane Doe',
    title: 'Software Engineer at XYZ Corp',
    location: 'San Francisco, CA',
    picture: 'https://via.placeholder.com/150',
    summary: 'Experienced developer specializing in React.js.',
    experience: ['Frontend Developer at ABC', 'Software Engineer at XYZ Corp'],
  },
  {
    id: 2,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  {
    id: 3,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  {
    id: 4,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  {
    id: 5,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  {
    id: 6,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  {
    id: 7,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
];

const handleConnect = (id) => {
  alert(`Connection request sent to: ${id}`);
  // Additional logic: Save this action to the backend or local state
};

const Group = () => {
  // Move the useState call here
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProfile, setSelectedProfile] = useState(null);

  const filteredProfiles = peopleData.filter((profile) =>
    profile.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleJoin = async (id) => {
    try {
      const response = await fetch(`http://127.0.0.1:5050/group/groups_api/${id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      const data = await response.json();
      if (response.ok) {
        alert(data.message);
      } else {
        alert(data.error || 'An error occurred');
      }
    } catch (error) {
      console.error('Error joining group:', error);
      alert('Failed to join group: ' + error.message);
    }
  };
  
  
  
return (
    <>
    <Header/>
    <div className='container-group'>
      <div className="people-page">
        <div className="people-list">
             {filteredProfiles.map((profile) => (
            <div
                key={profile.id}
                className="people-card"
                onClick={() => setSelectedProfile(profile)}>
                <img src={profile.picture} alt={`${profile.name}'s profile`} />
                <div className='prof'>
                  <h3>{profile.name}</h3>
                  <p>{profile.title}</p>
                  <p>{profile.location}</p>
                </div>
              <div className='join_btn'>
              <button onClick={(e) => {
                e.stopPropagation(); // Prevent event bubbling
                handleJoin(profile.id);}}>
                Join
              </button>
            </div>
          </div>
          ))}
        </div>
      </div>
    </div>
    </>
  );
};

export default Group;
